import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { TenantProvider } from './context/TenantContext.jsx';
import { EditModeProvider } from './context/EditModeContext.jsx';
import { AstryxThemeProvider } from './theme/AstryxThemeProvider.jsx';
import { CartProvider } from './store/cart.jsx';
import './index.css';

// Silence Cloudflare RUM CORS and analytics logs in console if running in browser
if (typeof window !== 'undefined') {
  const originalWarn = console.warn;
  const originalError = console.error;
  console.warn = (...args) => {
    const msg = args.map(String).join(' ');
    if (msg.includes('cloudflareinsights.com') || msg.includes('cdn-cgi/rum') || msg.includes('RUM')) return;
    originalWarn(...args);
  };
  console.error = (...args) => {
    const msg = args.map(String).join(' ');
    if (msg.includes('cloudflareinsights.com') || msg.includes('cdn-cgi/rum') || msg.includes('RUM')) return;
    originalError(...args);
  };
}

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <TenantProvider>
        <EditModeProvider>
          <AstryxThemeProvider>
            <CartProvider>
              <App />
            </CartProvider>
          </AstryxThemeProvider>
        </EditModeProvider>
      </TenantProvider>
    </StrictMode>,
  );
}
